import ServicePath from './Webservice';
const SocketPath = ServicePath.replace('http', 'ws').replace('https', 'wss');
export default SocketPath;
